<section
  id="auth-overlay-module"
  class="options-dialog"
  [class.rtl]="rtlMode"
  [class.md]="(screenSize$ | async) === 'md'"
  [class.sm]="(screenSize$ | async) === 'sm'"
  [class.mobileL]="(screenSize$ | async) === 'mobileL'"
  [class.mobileXL]="(screenSize$ | async) === 'mobileXL'"
  [class.xs]="(screenSize$ | async) === 'xs'"
  [class.mobileS]="(screenSize$ | async) === 'mobileS'"
  [class.xxs]="(screenSize$ | async) === 'xxs'"
  [class.bigger]="!(lessThan$ | async)?.mobileL">
  @if (mode === 'auth-intro') {
    <app-auth-intro
      [inDialog]="true"
      class="auth-form"
      [success-path]="successRedirect"
      [success-params]="successRedirectQueryParams"
      [skip-redirect]="skipRedirect"
      (closeDialog)="closeOverlay($event)"
      (handleRedirect)="onHandleRedirect()"
      (dialogModeChange)="updateDialogMode($event)">
    </app-auth-intro>
  }
  @if (mode === 'sign-in') {
    <app-email-sign-in
      [inDialog]="true"
      class="auth-form"
      [email]="email"
      [username]="username"
      [previous-mode]="modeAtStart"
      [success-path]="successRedirect"
      [success-params]="successRedirectQueryParams"
      [skip-redirect]="skipRedirect"
      (closeDialog)="closeOverlay($event)"
      (handleRedirect)="onHandleRedirect()"
      (dialogModeChange)="updateDialogMode($event)">
    </app-email-sign-in>
  }

  @if (mode === 'sms-sign-in') {
    <app-sms-sign-in
      class="auth-form"
      (closeDialog)="closeOverlay($event)"
      (handleRedirect)="onHandleRedirect()"
      (dialogModeChange)="updateDialogMode($event)" />
  }
</section>
